import { defineStore } from "pinia";
import { login, logout, getInfo, getUserId } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import defAva from "@/assets/images/profile.jpg";
import Cookies from "js-cookie";

const useUserStore = defineStore("user", {
  state: () => ({
    token: getToken(),
    id: "",
    deptId: "",
    deptName: "",
    name: "",
    nickName: "",
    avatar: null,
    roles: [],
    permissions: [],
    res: {}
  }),
  actions: {
    // 登录
    login(userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password;
      const code = userInfo.code;
      const uuid = userInfo.uuid;
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid)
          .then((res) => {
            console.log(res);
            setToken(res.token);
            this.token = res.token;
            resolve(res.redirect);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户信息
    getInfo() {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            const user = res.user;
            const avatar =
              user.avatar == "" || user.avatar == null
                ? null
                : process.env.VITE_APP_BASE_API + user.avatar;

            if (res.roles && res.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              this.roles = res.roles;
              this.permissions = res.permissions;
            } else {
              this.roles = ["ROLE_DEFAULT"];
            }
            console.log(user);
            this.id = user.userId;
            this.name = user.userName;
            this.nickName = user.nickName;
            this.avatar = avatar;
            Cookies.set('ruoyiIds', JSON.stringify({ userId: user.userId, deptId: user.deptId }));

            // 人员企业信息查询
            getUserId(user.userName, user.deptId).then((info) => {
              console.log(info, "1111111111111111111");
              this.res = info.data
              if (info.data) {
                this.deptId = info.data ? info.data.id : "";
                this.deptName = info.data ? info.data.name : "";
                Cookies.set('userInfo', JSON.stringify({ deptId: info.data.id + '', deptName: info.data.name }));
              }
            });

            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 退出系统
    logOut() {
      return new Promise((resolve, reject) => {
        logout(this.token)
          .then(() => {
            this.token = "";
            this.roles = [];
            this.permissions = [];
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    hasPermi(permi){
        const permissions = this.permissions;
        if (permissions.includes('*:*:*')){
            return true
        }
        return permissions.includes(permi)
    }
  },
});

export default useUserStore;
